// Lib
import { EditorState, SelectionState } from 'draft-js';

// TODO: Make this work for more than one line of text (if we need it to at some point)

export default (editorState) => {
    const text = editorState.getCurrentContent().getPlainText();
    const selection = editorState.getSelection();
    const startKey = selection.getStartKey();

    const newSelection = new SelectionState({
        anchorKey: startKey,
        anchorOffset: 0,
        focusKey: startKey,
        focusOffset: text.length,
    });

    return EditorState.forceSelection(editorState, newSelection);
};
